import React, { useEffect, useState, useContext } from 'react'
import { Tooltip } from '@mui/material'
import { Search } from '@mui/icons-material'
import { M_InputTextField, M_ElementDrawer, M_Table, BufferService, filtersSortService, LoadingContext } from '../../M_Components'
import { useTranslation } from 'react-i18next'

export function M_DrawerTableTextField({
    label, value, entity, filterField, fieldType, tableLabel, color,
    secondColor, FILTER, required, tooltipAdd, disabled, labelFields,
    onSubmitValue, size, icon, style, disabledColor, margin, translate, loadOnMount}) {
    const { t } = useTranslation()
    const [valueInput, setValueInput] = useState(value)
    const [onOpen, setOnOpen] = useState(false)
    const [options, setOptions] = useState([])

    const headerSize = document.body.getElementsByClassName('p-datatable-header')[0]?.offsetHeight || 60
    const paginatorSize = document.body.getElementsByClassName('paginator')[0]?.offsetHeight || 60
    const tabSize = 64
    const tempSize = (document.body.offsetHeight - (headerSize + paginatorSize + tabSize + 5))

    const entityService = new BufferService(entity)
    const filterService = new filtersSortService()

    const ctx = useContext(LoadingContext)

    color = color ? color : ctx.primaryColor ? ctx.primaryColor : "var(--color-black)"

    useEffect(() => {
        if (value !== valueInput) {
            setValueInput(value)
        }
    })

    useEffect(() => {
        if (loadOnMount) {
            const fetchInitialData = () => {
                const initialFilter = filterService.queryBuilder(1, 8, null, null, FILTER);
                
                entityService.filter(initialFilter).then(res => {
                    if (res.name === 'AxiosError') {
                        return; 
                    }
                    setOptions(res.Items);
                });
            };

            fetchInitialData();
        }
    }, [loadOnMount, entity, FILTER]);


    const openDrawer = () => {
        setOnOpen(true)
    }

    const closeDrawer = () => {
        setOnOpen(false)
    }

    const keyDown = (e) => {
        if (e.key === 'F4') {
            openDrawer()
        }
    }

    const getLine = (e) => {
        closeDrawer()
        onChangeValue(null, e[0], 'changevalue')
    }

    const returnTable = () => {
        if (onOpen) {
            return (
                <>
                    <h2 style={{ marginLeft: '10px', marginTop: '0px', marginBottom: '10px' }}>{tableLabel}</h2>
                    <M_Table
                        tableHeight={tempSize}
                        entityName={entity}
                        useSessionStorage={false}
                        crud={false}
                        onPassLine={getLine}
                        selectSingle={true}
                        FILTER={FILTER}
                    />
                </>
            )
        }
    }

    const getValues = (input) => {
        const tempInput = input.trim()
        if (filterField) {
            const tempArg = [{ name: filterField, type: fieldType, operation: 'Contains', value: tempInput }]
            const tempFilter = filterService.queryBuilder(1, 100, null, tempArg, FILTER)
            entityService.filter(tempFilter).then(res => {
                if (res.name === 'AxiosError') {
                    return
                }
                setOptions(res.Items)
            })
        }
    }

    const onChangeValue = (event, value, reason) => {
        if (reason == 'clear') {
            console.log('teste')
            setValueInput('a')
            onSubmitValue(value)
        }
        setValueInput(value)
        onSubmitValue(value)
    }

    const clickOption = (option) => {
        getLine([option])
    }

    return (
        <>
            <M_InputTextField
                autocomplete
                options={options}
                disabled={disabled}
                label={translate && t(label) || label}
                value={valueInput}
                onClickOption={clickOption}
                labelFields={labelFields}
                onChangeValue={onChangeValue}
                onChange={(e) => getValues(e.target.value)}
                onKeyDown={(e) => keyDown(e)}
                color={color}
                secondColor={secondColor}
                required={required}
                size={size ? size : '100%'}
                style={style}
                disabledColor={disabledColor}
                // margin={margin}
                InputProps={{
                    startAdornment: (
                        disabled ? <></> :
                            <Tooltip style={{ color: color, cursor: 'pointer' }} title={tooltipAdd ? tooltipAdd : ""} onClick={() => openDrawer()}>
                                {icon ? icon :
                                    <Search />
                                }
                            </Tooltip>
                    ),
                }}
            />
            <M_ElementDrawer
                open={onOpen}
                setOpen={setOnOpen}
                onClose={closeDrawer}
                element={returnTable()}
            />
        </>
    )
}